const API_TYPES_DROPDOWN_OPTIONS = [
  {
    label: "REST",
    value: "REST",
  },
  {
    label: "Async",
    value: "Async",
  },
  {
    label: "Bundles",
    value: "Bundles",
  },
];
const FILTER_TYPES_DROPDOWN_OPTIONS = [
  {
    label: "Bundles",
    value: "Bundles",
  },
  {
    label: "Contracted",
    value: "Contracted",
  },
];
const API_TYPES_DROPDOWN_OPTIONS_OLD = [
  {
    label: "REST APIs",
    value: "REST APIs",
  },
  {
    label: "Async APIs",
    value: "Async APIs",
  },
];
const PAGINATION = {
  LIMIT: 12,
};
const PAGINATION_BUNDLE = {
  LIMIT: 2,
  EXTENDED_LIMIT: 10,
};
const PAGINATION_CONTRACTED_APIS = {
  LIMIT: 4,
};
const SHOW_MORE_APIS = 'Show More APIs'
const API_TYPES = {
  REST: "rest-api",
  // bundleDetails.apis[].type is "api" or "async-api".
  // you should be fine doing `if (type === API_TYPES.ASYNC) {...} else {...}`
  ASYNC: "async-api",
};
const ERROR_STATEMENT =
   'The following Error(s) needs to be fixed to get a response:';

const TEST_SIMULATOR_SUB_HEADER =
  "This tool lets you review what's needed to make calls to this API using examples from the API Specification to show the responses you can expect to see from a request. Random values are generated for all input parameters and reflect the type of the value expected by the API service. If needed by a method, a request body is provided from the specification.";

const API_TYPES_VALUE = ["Async APIs", "REST APIs"];

const BUILD_WITH_BUNDLES = {
  NEW_APP: 'newApp',
  EDIT_APP :'editApp'}

const BUILD_WITH_API ={
   NEW_APP: 'newApp',
  EDIT_APP :'editApp'
}

const PLAN ={
  SUBSCRIPTION: 'Subscription Plan'
}

const SHOW_MORE= 'Show more';
const SHOW_LESS= 'Show less'

const RESTRICTED_SHARED_STATUS = {
  NOT_REQUESTED: "not-requested",
  REQUESTED: "requested",
};

const BTN_TEXT = {
  ADD_TO_CART: "Add to Cart",
  ADDED_TO_CART: "Added to Cart",
  VIEW_IN_MY_APIS: "View in My APIs",
  REQUESTED_ACCESS: "Requested Info",
  REQUEST_ACCESS: "Request Info",
};

const BUNDLE_TYPE = {
  PRICE: "price",
  GENERAL: "general",
};

export {
  API_TYPES_DROPDOWN_OPTIONS,
  API_TYPES_DROPDOWN_OPTIONS_OLD,
  PAGINATION,
  PAGINATION_BUNDLE,
  PAGINATION_CONTRACTED_APIS,
  API_TYPES,
  ERROR_STATEMENT,
  TEST_SIMULATOR_SUB_HEADER,
  FILTER_TYPES_DROPDOWN_OPTIONS,
  SHOW_MORE_APIS,
  API_TYPES_VALUE,
  BUILD_WITH_BUNDLES,
  BUILD_WITH_API,
  PLAN,
  SHOW_MORE,
  SHOW_LESS,
  RESTRICTED_SHARED_STATUS,
  BTN_TEXT,
  BUNDLE_TYPE
};
